import React, { Suspense, useState, useEffect } from "react";
import { Modal } from 'react-responsive-modal';
import { Details_Template } from "./ClientProfilePortal/details_clients_tpl";
import { Reserves_Template } from "./ClientProfilePortal/reserves_client_profile_tpl";
import DSP_Management from "./ClientProfilePortal/client_manageDSP";
import Zone_Management from "./ClientProfilePortal/client_manageZone";
import FTP_Management from "./ClientProfilePortal/client_manageFTP";
import Email_Template from "./ClientProfilePortal/emailSettings";
import StatementApproval_Template from "./ClientProfilePortal/statementApproval";
import LicensingClientProfile from "./ClientProfilePortal/licensing";
import Logo_Template from "./ClientProfilePortal/logo_client_profile_tpl";

export default function ClientProfile(param: any) {

    console.log("ClientProfile")

    const [showtab, setShowTab] = useState(1);
    const [openFirst, setOpenFirst] = React.useState(false);

    const handleCloseModal = () => {
        setOpenFirst(false);
        setShowTab(1);
    }

    const menu = [
        { label: 'Menu', value: 'Detail' },
        { label: 'Menu', value: 'Reserve' },
        { label: 'Menu', value: 'Upload Logo' },
        { label: 'Menu', value: 'Zone Management' },
        { label: 'Menu', value: 'DSP Management' },
        { label: 'Menu', value: 'FTP Management' },
        { label: 'Menu', value: 'Email Template' },
        { label: 'Menu', value: 'Statement Approval' },
        { label: 'Menu', value: 'Licensing' },
    ];


    const closeModal = (e: any) => {
        //setShowTab(false);
        const modal = document.getElementById("myModal") as HTMLElement;
        modal?.classList.remove("displayItem");
        modal?.classList.add("displayNoneItem");
        document.body.classList.remove("HiddenoverflowX");
    }

    return (<>
        {<div id="myModal" className="modal pLarge ws-12 ">
            <a onClick={() => closeModal(true)} className="btn-xxs modalClose borderNone bgTransparent" style={{ position: "inherit" }} href="../../">
                <i className="icon-close3 danger"></i>
            </a>

            <div className="allowHscroll allowVscroll full-height-vh95 ws-12 box" style={{ minHeight: "80%" }}>

                <div className="ws-2 pm borderReset full-height pLarge">

                    <div className="ws-12 text-center pLarge mtll mbl"><img alt="Korrect"  className="pull-none" src="/static/media/korrectLogoIcon.2b7d4c4892ef79abbce4.png" width="50" /></div>

                    <div className="main-menu-span m0">
                        <div className="sidebar-nav">
                            <ul className="main-menu pll prl ws-12">

                                <a className="full-width text-bold text-average text-m mtl ws-12 pbl"> Menu</a>
                                <ul >
                                    {
                                        menu.map((values: any, index: any) => {

                                            if (values.label === 'Menu') {
                                                return (<>
                                                    <li className={showtab === index + 1 ? "active" : ""}
                                                        onClick={() => setShowTab(index + 1)}>
                                                        <a className="ws-12 text-sl text-normal" > {values.value} </a>
                                                    </li>
                                                </>)
                                            }
                                        })
                                    }
                                </ul>
                            </ul>
                        </div>

                    </div>

                </div>

                <div className="ws-10 pm landing">

                    <div className="ws-12 ptl pbl">
                        <span className="ws-12 text-bold text-xl">Client Profile</span>
                        <span className="ws-12 ptl text-bold text-m turquoise">{menu[showtab - 1]?.value}</span>
                    </div>
                    {(() => {

                        if (showtab == 1) {
                            return <Details_Template param={"open"} />
                        }
                        if (showtab === 2) {
                            return <Reserves_Template param="open" />;
                        }

                        if (showtab === 3) {
                            return <Logo_Template param="open" />;
                        }

                        if (showtab === 4) {
                            return <Zone_Management param="open" />;
                        }

                        if (showtab === 5) {
                            return <DSP_Management param="open" />;
                        }

                        if (showtab === 6) {
                            return <FTP_Management param="open" />;
                        }

                        if (showtab === 7) {
                            return <Email_Template param="open" />;
                        }

                        if (showtab === 8) {
                            return <StatementApproval_Template param="open" />;
                        }

                        if (showtab === 9) {
                            return <LicensingClientProfile />;
                        }
                    })()}
                </div>
            </div>

        </div>}
    </>
    );
}